'use strict';

var app = angular.module('analytics');

app.controller('OrganizationClonePanelCtrl', [
    '$scope',
    'organizationFactory',
    'storageFactory',
    'reportFactory',
    function ($scope, organizationFactory, storageFactory, reportFactory) {
        $scope.selected = organizationFactory.getSelected();
        var parentScope = organizationFactory.getParentScope();
        $scope.newName = "";
        $scope.newDescription = "";

        $scope.clone = function() {
            let newOrg = {};
            newOrg.name = $scope.newName;
            newOrg.description = $scope.newDescription;

            organizationFactory.create(newOrg).then(function (createdOrg) {
                reportFactory.getByProperty("organization", $scope.selected.id).then(repData => {
                    repData = repData.data.map(el => {
                        el.id = null;
                        el.src = "src";
                        el.organization = createdOrg.data.id;
                        return el;
                    });
                    repData.forEach(rep => {
                        reportFactory.create(rep);
                    });
                });
            });

            parentScope.closePanel();
        };
}]);
//# sourceMappingURL=reportCtrl.js.map